import { useSupportedDeviceProducts } from "@/hooks/useSupportedDeviceProducts";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/v2-components/ui/carousel";
import ProductCard from "@/v2-components/ProductCard";
import { DeviceType } from "@/services/ContentsService";
import { Product } from "@/api/product-api";
import { useTrans } from "@/utils/useTrans";

interface Props {
  devices: DeviceType[];
  /** 게임별 번들 교체(`GAME_SUPPORTED_DEVICE_SWAPS`)용 — 예: EXOSHOCK 게임에서 EXOSHOCK 번들. */
  gameSlug?: string;
}

export default function SupportedDevices({ devices, gameSlug }: Props) {
  const { t } = useTrans(["games"]);
  // 기기·번들·순서 규칙은 한 곳 — `useSupportedDeviceProducts`(웹·앱 웹뷰 공통).
  const supportedDevices = useSupportedDeviceProducts(devices, gameSlug);
  return (
    // `supported-devices` — AI 햅틱 요약 카드의 「지원 기기 보기」 스크롤 목적지(HapticSummaryCard)
    <div id="supported-devices" className="scroll-mt-28">
      <h2 className="mb-5 px-4 text-2xl laptop:mb-8 laptop:px-0 laptop:text-3xl">
        {t("Supported Devices")}
      </h2>
      <Desktop supportedDevices={supportedDevices} />
      <Mobile supportedDevices={supportedDevices} />
    </div>
  );
}

function Desktop({ supportedDevices }: { supportedDevices?: Product[] }) {
  return (
    <Carousel
      opts={{
        align: "start",
        slidesToScroll: 1,
      }}
      className="hidden w-full smd:block"
    >
      <CarouselContent className="ml-4 laptop:-ml-4">
        {supportedDevices?.map((product) => (
          <CarouselItem
            key={product.id}
            className="basis max-w-[90%] pl-0 pr-4 smd:basis-1/4 laptop:basis-1/5 laptop:pl-4 laptop:pr-0"
          >
            <ProductCard product={product} showDesc={false} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="invisible top-1/2 translate-x-1/3 disabled:invisible laptop:visible max:-translate-x-1/2" />
      <CarouselNext className="invisible top-1/2 -translate-x-1/3 disabled:invisible laptop:visible max:translate-x-1/2" />
    </Carousel>
  );
}

function Mobile({ supportedDevices }: { supportedDevices?: Product[] }) {
  return (
    <div className="mx-4 grid grid-cols-2 gap-x-4 gap-y-6 smd:hidden">
      {supportedDevices?.map((product) => (
        <ProductCard product={product} showDesc={false} key={product.id} />
      ))}
    </div>
  );
}
